import { ArrowIcon } from '@assets/icons/ArrowIcon'
import { HeaderButton } from '@components/ButtonSignin/ButtonSignin.style'
import { useTheme } from '@mui/material'

export const ResponsiveHeaderButton = ({
  children,
  isSmallDevice,
  onClick,
}) => {
  const theme = useTheme()

  return (
    <HeaderButton onClick={onClick} endIcon={isSmallDevice ? ArrowIcon : null}>
      {children}
    </HeaderButton>
  )
}
